import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import EmojiFlagsOutlinedIcon from "@mui/icons-material/EmojiFlagsOutlined";
import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
import { Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { PlanningTask } from "src/stateManagement/redux/slices/planificacion/interfaces";
import ChecklistIcon from '@mui/icons-material/Checklist';

const Tasks = ({ task }: {task:PlanningTask}) => {

    return (
        <Link to={`/gto/task/info/${task.id}`} style={{ textDecoration: "none" }}>
            <Paper
                elevation={3}
                sx={{
                    mt: 3,
                    padding: "10px",
                    "&:hover": {
                        border: "1px solid  #129ED3",
                    },
                }}
            >
                <Typography
                    variant="body1"
                    color="initial"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "12px",
                    }}
                >
                    {task.asignedGroup} - {task.tecnology}
                </Typography>
                <Typography
                    variant="body1"
                    color="initial"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "#797878",
                    }}
                >
                    {task.type}
                </Typography>
                <Typography
                    variant="body1"
                    color="initial"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "#797878",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <AccountCircleOutlinedIcon sx={{ mr: 0.5 }} />
                    asignado a: {task.asignedUserName}
                </Typography>
                <Typography
                    variant="body1"
                    color="initial"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "#797878",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <CalendarMonthOutlinedIcon sx={{ mr: 0.5 }} />
                    fecha plan: {task?.planningStartDate ? task.planningStartDate.toString() : ""}
                </Typography>
                <Typography
                    variant="body1"
                    color="initial"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "#797878",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <EmojiFlagsOutlinedIcon sx={{ mr: 0.5 }} />
                    Fecha culminada: {task?.planningEndDate ? task.planningEndDate.toString() : ""}
                </Typography>
                <Typography
                    variant="body1"
                    color="initial"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "#797878",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <LoopOutlinedIcon sx={{ mr: 0.5 }} />
                    avance: {task.advance} % 
                </Typography>
                <Typography
                    variant="body1"
                    color="initial"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "#797878",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <ChecklistIcon sx={{ mr: 0.5 }} />
                    requrimientos: {task.numberOfRequirements}
                </Typography>
            </Paper>
        </Link>
    );
};

export default Tasks;
